import { createAction } from '@reduxjs/toolkit';
import { ICava } from '../../../interfaces/place/models';
import { EMPTY, GET, ICavaState, LIST } from './types';

export const listAction = createAction<ICavaState>(LIST);

export const getAction = createAction<ICava>(GET);

export const emptyAction = createAction(EMPTY);

